import { NavBar } from "../components/NavBar.tsx";
import { useAuthSessionContext } from "../components/routing/auth-session-store";
export const LayoutChat = ({ children }: { children: React.ReactNode }) => {
	const { session } = useAuthSessionContext();
	return (
		<div className='flex min-h-dvh flex-col overflow-hidden'>
			<NavBar isLogged={Boolean(session)} />
			<main className='z-0 flex min-h-0 flex-1 overflow-hidden font-[Inter]'>
				{children}
			</main>
		</div>
	);
};
